import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/settings/app.scss';
import {Route, Routes} from "react-router-dom";
import {routes} from "./storage/constants/routes";
import Page from "./pages/schemaPages/Page";
import HomePage from "./pages/HomePage";
import WordCounter from "./pages/apps/word-counter/WordCounter";
import ExponentialInterestCalculator from "./pages/apps/exponential-compound-calculator/ExponentialInterestCalculator";
import CompoundInterestCalculator from "./pages/apps/compound-interest-calculator/CompoundInterestCalculator";
import MyIP from "./pages/apps/my-ip/MyIP";
import TaxCalculator from "./pages/apps/tax-calculator/TaxCalculator";
import PasswordGenerator from "./pages/apps/password-generator/PasswordGenerator";
import Apps from "./pages/Apps";
import Games from "./pages/Games";
import TicTacToe from "./pages/games/tic-tac-toe/TicTacToe";
import {TermsAndConditions} from "./pages/TermsAndConditions";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";

function App() {
  return (
      <Routes>
        <Route path={routes.home} element={<Page><HomePage/></Page>} />
        <Route path={routes.apps} element={<Page><Apps/></Page>} />
        <Route path={routes.games} element={<Page><Games/></Page>} />
        <Route path={routes.termsAndConditions} element={<Page><TermsAndConditions/></Page>} />
        <Route path={routes.privacyPolicy} element={<Page><PrivacyPolicy/></Page>} />

        <Route path={routes.wordCounter} element={<Page><WordCounter/></Page>} />
        <Route path={routes.myIP} element={<Page><MyIP/></Page>} />
        {/*<Route path={routes.passwordGenerator} element={<Page><PasswordGenerator/></Page>} />*/}
        {/*<Route path={routes.taxCalculator} element={<Page><TaxCalculator/></Page>} />*/}
        {/*<Route path={routes.exponentialInterestCalculator} element={<Page><ExponentialInterestCalculator/></Page>} />*/}
        {/*<Route path={routes.compoundInterestCalculator} element={<Page><CompoundInterestCalculator/></Page>} />*/}

        <Route path={routes.ticTacToe} element={<Page><TicTacToe/></Page>} />

        <Route path={routes.undefined} element={<Page><HomePage/></Page>} />
      </Routes>
  );
}

export default App;